import { useMemo } from 'react';

import { useRouter } from 'react-resource-router';

import { PlacementPreviewProvider } from '@atlassian/post-office-placement-preview-provider';
import { Placement } from '@atlassian/post-office-placement-remote';
import { type PlacementOnEvent } from '@atlassian/post-office-placement-shared';

import { captureExceptionWithTags } from 'src/utils/sentry';

const POST_OFFICE_SCREEN_SPACE_FLAGS_PLACEMENT_ID = 'screen-space-flags';

const PlacementComponent = () => {
  const handleEvent: PlacementOnEvent = event => {
    if (event.type.includes('error')) {
      captureExceptionWithTags(
        event.error instanceof Error ? event.error : new Error(event.type),
        {
          placementId: POST_OFFICE_SCREEN_SPACE_FLAGS_PLACEMENT_ID,
        }
      );
    }
  };

  return (
    <Placement
      placementId={POST_OFFICE_SCREEN_SPACE_FLAGS_PLACEMENT_ID}
      disableInitialData
      onEvent={handleEvent}
    />
  );
};

export const ScreenSpaceFlagsPlacement = (): JSX.Element | null => {
  const [routerState] = useRouter();
  const query = useMemo(() => routerState.query, [routerState.query]);

  if (!routerState) {
    return null;
  }

  const previewId = query.contentfulPreviewId;
  const localeForPreview = query?.locale || 'en-US';
  const eligibleMessages = [
    {
      messageInstanceId: '12345678-1234-1234-1234-123456789012',
      messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
      messageCategory: 'Engagement',
      context: { id: previewId, localeForPreview },
      createdAt: new Date().toString(),
      eventTime: new Date().toString(),
      triggerId: '12345678-1234-1234-1234-123456789012',
      messageCreationType: 'explicit',
    },
  ];

  if (previewId) {
    return (
      <PlacementPreviewProvider eligibleMessages={eligibleMessages}>
        <PlacementComponent />
      </PlacementPreviewProvider>
    );
  }

  return <PlacementComponent />;
};
